import React, { useEffect } from 'react';
import { Calendar, Clock, CheckCircle } from 'lucide-react';

const Schedule = () => {
  useEffect(() => {
    // Redirect to Calendly after a brief moment
    const timer = setTimeout(() => {
      window.location.href = 'https://calendly.com/joede1123';
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="gradient-bg pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto text-center">
          <div className="w-20 h-20 mx-auto mb-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
            <Calendar className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Schedule a Consultation
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto mb-8">
            Redirecting you to our scheduling system...
          </p>
          <div className="inline-block">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-6" style={{ color: '#64B7B7' }}>
              What to Expect
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#A3D9D9' }}>
                <Clock className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#64B7B7' }}>
                15-Minute Consult
              </h3>
              <p className="text-gray-600">
                Brief initial conversation to understand your needs and determine fit
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#78C4C4' }}>
                <CheckCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#64B7B7' }}>
                Clear Next Steps
              </h3>
              <p className="text-gray-600">
                You'll know exactly what service fits your situation and what it will cost
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ backgroundColor: '#64B7B7' }}>
                <Calendar className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#64B7B7' }}>
                No Obligation
              </h3>
              <p className="text-gray-600">
                The consultation is complimentary and there's no pressure to proceed
              </p>
            </div>
          </div>

          <div className="text-center bg-gray-50 p-8 rounded-xl">
            <p className="text-lg text-gray-700 mb-4">
              If you're not automatically redirected, click the button below:
            </p>
            <a 
              href="https://calendly.com/joede1123"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold px-10 py-4 rounded-lg text-lg font-bold inline-block"
            >
              Go to Scheduling Page
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Schedule;
